import { Directive } from '@angular/core';
import { BrnAccordionItem } from '@spartan-ng/brain/accordion';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmAccordionItem],hlm-accordion-item',
  hostDirectives: [
    { directive: BrnAccordionItem, inputs: ['isOpened', 'disabled'], outputs: ['stateChange'] },
  ],
  host: { 'data-slot': 'accordion-item' },
})
export class HlmAccordionItem {
  constructor() {
    classes(() => 'border-border block border-b last:border-b-0');
  }
}
